module.exports = __webpack_public_path__ + "static/media/water.358472ea.svg";